import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Tooltip from 'gnos-tooltip'
import config from '@config'

import './style.scss'

const version = window.version ? window.version : config.versionNumber

export default class Version extends Component {
    render() {
        const text = (
            <FormattedMessage id={'scenes.Gnosus.components.MainMenu.components.Version.text'} values={{ version }} />
        )

        return (
            <Tooltip id={'version_tag'} content={text} onlyTruncated>
                <div className={'version'}>{text}</div>
            </Tooltip>
        )
    }
}
